module.exports = __webpack_public_path__ + "static/media/plus_sign.fd227402.svg";